import { environment } from '../../environments/environment';

export interface IDotenv {
  localEnv: string;
  baseUrl: string;
  uniprotApiUrl: string;
  uniprotEntryUrl: string;
  entryApiUrl: string;
  providerApiUrl: string;
  pdbeApiUrl: string;
  pdbeKbEntryUrl: string;
  googleAnalyticsTag: string;
  searchApiUrl: string;
  downloadApiUrl: string;
  suggestApiUrl: string;
  apiKey: string;
  swaggerApiUrl: string;
  clusterApiUrl: string;
  structureSearchApiUrl: string;
  pdbeBaseApiUrl: string;
  domainsApiUrl: string;
}

export const dotenv: IDotenv = {
  localEnv: environment.localEnv,
  baseUrl: environment.baseUrl,
  uniprotApiUrl: environment.uniprotApiUrl,
  uniprotEntryUrl: environment.uniprotEntryUrl,
  entryApiUrl: environment.entryApiUrl,
  providerApiUrl: environment.providerApiUrl,
  pdbeApiUrl: environment.pdbeApiUrl,
  pdbeKbEntryUrl: environment.pdbeKbEntryUrl,
  googleAnalyticsTag: environment.googleAnalyticsTag,
  searchApiUrl: environment.searchApiUrl,
  downloadApiUrl: environment.downloadApiUrl,
  suggestApiUrl: environment.suggestApiUrl,
  apiKey: environment.apiKey ? environment.apiKey : '',
  swaggerApiUrl: environment.swaggerApiUrl,
  clusterApiUrl: environment.clusterApiUrl,
  structureSearchApiUrl: environment.structureSearchApiUrl,
  pdbeBaseApiUrl: environment.pdbeBaseApiUrl,
  domainsApiUrl: environment.domainsApiUrl
};